import { createContext } from 'react';

export const GameContext = createContext(null);